import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Form } from 'antd'

import Input from '../../common/Input'
import css from './ManualForm.css'

const inputs = [{
  label: 'Name',
  name: 'name',
}, {
  label: 'Website',
  name: 'website',
}, {
  label: 'Street Address',
  name: 'street_address',
}, {
  label: 'Secondary Address (optional)',
  name: 'secondary_address',
}, {
  label: 'City',
  name: 'city',
}, {
  label: 'State',
  name: 'state',
}, {
  label: 'Zip',
  name: 'zip',
}]

export default class LocationForm extends Component {
  static propTypes = {
    addOrEdit: PropTypes.func.isRequired,
    hideForm: PropTypes.func.isRequired,
    location: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      website: PropTypes.string.isRequired,
      street_address: PropTypes.string.isRequired,
      secondary_address: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      zip: PropTypes.string.isRequired,
    }),
    websiteFromProps: PropTypes.string,
  }

  static defaultProps = {
    location: null,
    websiteFromProps: null,
  }

  state = {
    name: '',
    website: '',
    street_address: '',
    secondary_address: '',
    city: '',
    state: '',
    zip: '',
    isLoading: false,
  }

  componentWillMount() {
    const { location, websiteFromProps } = this.props
    if (location) {
      const {
        name, website, street_address, secondary_address, city, state, zip, isLoading,
      } = location
      this.setState({
        name, website, street_address, secondary_address, city, state, zip, isLoading,
      })
    } else if (websiteFromProps) {
      this.setState({ website: websiteFromProps })
    }
  }

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.setState({
      isLoading: true,
    })
    const {
      name, website, street_address, secondary_address, city, state, zip,
    } = this.state
    const locationId = this.props.location ? this.props.location.id : undefined
    this.props.addOrEdit({
      name, website, street_address, secondary_address, city, state, zip,
    }, locationId)
      .then(() => {
        this.props.hideForm()
      })
  }

  render() {
    return (
      <Form
        layout="horizontal"
        onSubmit={this.handleSubmit}
        className={css.form}
      >
        <div className={css.header}>
          <h3>New Location:</h3>
          <Button
            icon="close"
            onClick={this.props.hideForm}
            shape="circle"
          />
        </div>
        {inputs.map(input => (
          <Input
            key={input.name}
            label={input.label}
            value={this.state[input.name]}
            name={input.name}
            onChange={this.onInputChange}
          />
        ))}
        <Form.Item className={css.button}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={!this.state.name || !this.state.website || !this.state.street_address || !this.state.city || !this.state.state || !this.state.zip}
            loading={this.state.isLoading}
          >
            Submit
          </Button>

        </Form.Item>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/AddPractice/Info/LocationForm.js